export const getCandidateTitle = (status:string)=>{
    switch(status) {
        case 'all': return 'Все кандидаты'
        case 'processing': return 'Кандидаты в процессе'
        case 'completed' : return 'Завершенные кандидаты'
        default: return ''
    }
}